import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getClinicSubscriptionStatus } from '../../Services/APIs/appDetails';
import { getFlowDecision } from '../../Utils/clinicFunnel';

const useResolveDestination = () => {
    const navigate = useNavigate();
    const [statusError, setStatusError] = useState('');
    const [isResolving, setIsResolving] = useState(false);

    const resolveDestination = async () => {
        setStatusError('');
        setIsResolving(true);
        try {
            const response = await getClinicSubscriptionStatus();
            const route = getFlowDecision(response?.data?.data.status, response?.data?.data.subscription_status);
            navigate(route, { replace: true });
        } catch (error) {
            console.error('Error fetching subscription status:', error);
            setStatusError("We couldn't check your account status.");
        }
        setIsResolving(false);
    };

    return { resolveDestination, statusError, clearStatusError: () => setStatusError(''), isResolving };
};

export default useResolveDestination;
